/**
 * Prerequisitos de salida a producción del sitio corporativo.
 * Detalle operativo: docs/go-live.md
 */

export const GO_LIVE_BLOCK = {
  title: "Despliegue general — Website",
  summary:
    "Condiciones para publicar agdysa.com (Firebase Hosting + FTP). No sustituyen la prueba en local.",
  note: "Push a main despliega Hosting y el mirror FTP. Functions y rules solo con workflow_dispatch o CLI.",
};

/** @typedef {'completed' | 'in_progress' | 'pending'} GoLiveItemStatus */

/** @type {{ id: string, title: string, description: string, status: GoLiveItemStatus }[]} */
export const GO_LIVE_PREREQUISITES = [
  {
    id: "ci-hosting-ftp",
    title: "CI de Hosting y FTP",
    description:
      "Workflow Deploy AGDYSA en main: build dist/ → Firebase Hosting (agdysa-52935) → FTP ftp.agdysa.com. Secrets FIREBASE_SERVICE_ACCOUNT_AGDYSA y FTP_*.",
    status: "completed",
  },
  {
    id: "smtp-otp",
    title: "OTP staff por correo institucional",
    description:
      "Cloud Functions website-cms con secreto SMTP_PASS. Login /admin: Auth + OTP noreply@agdysa.com → cmsSessions.",
    status: "in_progress",
  },
  {
    id: "firestore-storage-rules",
    title: "Rules e índices en producción",
    description:
      "Desplegar firestore.rules, firestore.indexes.json y storage.rules desde website/ (CLI o Actions con deploy_rules).",
    status: "in_progress",
  },
  {
    id: "auth-domains",
    title: "Dominios autorizados en Auth",
    description:
      "agdysa.com, www.agdysa.com, agdysa-52935.web.app y agdysa-52935.firebaseapp.com en Authentication → Settings → Authorized domains.",
    status: "in_progress",
  },
  {
    id: "contenido-cms",
    title: "Contenido CMS publicado",
    description:
      "Identidad (marca, HERO, Medios), Home, Footer, navegación y páginas clave guardadas en Firestore (default). Probar hero YouTube/Facebook en el dominio publicado.",
    status: "in_progress",
  },
  {
    id: "usuarios-staff",
    title: "Usuarios reales del panel",
    description:
      "Owners/admins/editores activos en /admin/users, systems con website, OTP verificado. Idle staff 10 min; operativos 8 h.",
    status: "in_progress",
  },
  {
    id: "apache-spa",
    title: "SPA en el hosting FTP",
    description:
      "dist/.htaccess (desde public/) reescribe rutas /admin y páginas internas a index.html. Sin clean-slate (no borrar WordPress legado).",
    status: "completed",
  },
  {
    id: "respaldo-dns",
    title: "DNS, TLS y respaldo",
    description:
      "DNS agdysa.com → Hosting/FTP; certificado HTTPS; política de backup Firestore (default) y del FTP.",
    status: "pending",
  },
];

export function getGoLiveCompletion() {
  const total = GO_LIVE_PREREQUISITES.length;
  const completed = GO_LIVE_PREREQUISITES.filter((item) => item.status === "completed").length;
  const inProgress = GO_LIVE_PREREQUISITES.filter((item) => item.status === "in_progress").length;
  return { completed, inProgress, pending: total - completed - inProgress, total };
}
